import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

import Login from "@/pages/Login";
import Create from "@/pages/Create";
import Generating from "@/pages/Generating";
import Preview from "@/pages/Preview";
import Dashboard from "@/pages/Dashboard";
import Subscribe from "@/pages/Subscribe";
import SiteDetail from "@/pages/SiteDetail";
import Leads from "@/pages/Leads";
import Domain from "@/pages/Domain";
import Referrals from "@/pages/Referrals";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]"><Loader2 className="w-8 h-8 text-[#C9A24B] wt-spin" /></div>;
  }
  return user ? children : <Navigate to="/login" replace />;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]"><Loader2 className="w-8 h-8 text-[#C9A24B] wt-spin" /></div>;
  }
  return user ? <Navigate to="/dashboard" replace /> : children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster theme="dark" position="top-center" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/create" element={<Protected><Create /></Protected>} />
          <Route path="/generating" element={<Protected><Generating /></Protected>} />
          <Route path="/preview/:siteId" element={<Protected><Preview /></Protected>} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/subscribe" element={<Protected><Subscribe /></Protected>} />
          <Route path="/sites/:siteId" element={<Protected><SiteDetail /></Protected>} />
          <Route path="/leads" element={<Protected><Leads /></Protected>} />
          <Route path="/referrals" element={<Protected><Referrals /></Protected>} />
          <Route path="/sites/:siteId/domain" element={<Protected><Domain /></Protected>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
